import ArrowDownIcon from '@images/icons/chevron-down-black.svg?react'
import ArrowUpIcon from '@images/icons/chevron-up-black.svg?react'
import { invoiceStatuses } from 'mmfintech-backend-api'

import './invoiceStatusRow.scss'

const StatusColorsMap = {
  [invoiceStatuses.CANCELED]: 'canceled',
  [invoiceStatuses.OPENED]: 'opened',
  [invoiceStatuses.PAID]: 'paid',
  OPEN: 'opened',
  CANCELLED: 'canceled',
  OVERDUE: 'overdue'
}

export const InvoiceStatusRow = ({
  data,
  className = '',
  isOpen
}: {
  data?: any
  className?: string
  isOpen?: boolean
}) => {
  if (!data?.label) return null

  return (
    <div
      data-test='selection-element-label'
      className={`body-medium invoice-status status-${StatusColorsMap[data?.value || data]} ${className}`}
    >
      <div>{data?.label || data}</div>
      {isOpen !== undefined && <div className='arrow'> {isOpen ? <ArrowUpIcon /> : <ArrowDownIcon />}</div>}
    </div>
  )
}
